const shell = {
  collapsible: {
    showLess: 'Show less',
    showMore: 'Discover what this means →',
  },

  error: {
    eyebrow: 'Something went wrong',
    titleLead: 'Let us pause.',
    titleAccent: 'We are on it.',
    body: 'Part of the app did not respond as expected. Your answers so far are saved locally — reload the page to carry on. If it still does not work, I am happy to help you personally.',
    reload: 'Reload the page',
    mailLink: 'Send Judith a message →',
    mailSubject: 'Error report TOF Persona',
  },
};

export default shell;
